import {
  Box,
  Button,
  Flex,
  Grid,
  Select,
  Textarea,
  TextInput,
} from "@mantine/core";
import { IconCheck } from "@tabler/icons-react";
import { repositoryPos } from "../../../_base/_const/_constVar";
import { MessageResponse } from "../../../model/MessageResponse";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { useState } from "react";
import { modals } from "@mantine/modals";

interface dataSubmit {
  orderNumber: string;
  attribute76: string;
  attribute77: string;
  attribute78: string;
  attribute71: string;
}

const TransferShippingFromCOD = ({
  onSuccess,
  orderNumber,
}: {
  onSuccess: any;
  orderNumber: string;
}) => {
  const [dataSubmit, setDataSubmit] = useState<dataSubmit>({
    orderNumber: orderNumber,
    attribute76: "",
    attribute77: "",
    attribute78: "DA_DONG_GOI",
    attribute71: "",
  });
  const [loadingButton, setLoadingButton] = useState<boolean>(false);
  const [deliveryMore, setDeliveryMore] = useState<string>("");

  const handleSubmit = async () => {
    if (
      !dataSubmit?.attribute76 ||
      String(dataSubmit?.attribute76).length === 0
    ) {
      NotificationExtension.Fails("Vui lòng chọn đơn vị vận chuyển !");
    } else if (
      dataSubmit?.attribute76 === "KHAC" &&
      deliveryMore.length === 0
    ) {
      NotificationExtension.Fails("Vui lòng nhập tên đơn vị vận chuyển khác !");
    } else if (dataSubmit?.attribute77?.length === 0) {
      NotificationExtension.Fails("Vui lòng nhập mã vận đơn !");
    } else {
      setLoadingButton(true);
      const res = await repositoryPos.post<MessageResponse<any>>(
        "/api/v1/CreateSellItem/update-shipping-t2",
        {
          ...dataSubmit,
          attribute76:
            dataSubmit?.attribute76 === "KHAC"
              ? deliveryMore
              : dataSubmit?.attribute76,
        },
      );

      if (res && res?.success) {
        NotificationExtension.Success("Cập nhật đơn COD thành công !");
        setTimeout(() => {
          onSuccess();
          setLoadingButton(false);
          modals.closeAll();
        }, 1000);
      } else {
        setLoadingButton(false);
      }
    }
  };

  return (
    <Box w={"35vw"} maw={500}>
      <Grid mt={5}>
        <Grid.Col span={12}>
          <Select
            label={"Đối tác vận chuyển"}
            placeholder="Chọn đối tác vận chuyển"
            value={dataSubmit.attribute76}
            data={[
              { label: "Nhất Tín", value: "NHAT_TIN" },
              { label: "Tín Thành", value: "TIN_THANH" },
              { label: "Nasco", value: "NASCO" },
              { label: "Viettel", value: "VIETTEL" },
              { label: "Khác", value: "KHAC" },
            ]}
            clearable
            onChange={(e) =>
              setDataSubmit((prev) => ({
                ...prev,
                attribute76: e ? e : "",
              }))
            }
            withAsterisk
          />
        </Grid.Col>
        {dataSubmit.attribute76 === "KHAC" ? (
          <Grid.Col span={12}>
            <TextInput
              label="Đơn vị vận chuyển khác"
              placeholder="Nhập tên đơn vị vận chuyển khác"
              value={deliveryMore}
              onChange={(e) => setDeliveryMore(e.currentTarget.value)}
              withAsterisk
            />
          </Grid.Col>
        ) : (
          <></>
        )}
        <Grid.Col span={12}>
          <TextInput
            label="Mã vận đơn"
            placeholder="Nhập mã vận đơn"
            value={dataSubmit.attribute77}
            onChange={(e) =>
              setDataSubmit((prev) => ({
                ...prev,
                attribute77: e.currentTarget.value,
              }))
            }
            withAsterisk
          />
        </Grid.Col>
        <Grid.Col span={12}>
          <Textarea
            label="Ghi chú"
            placeholder="Nhập ghi chú"
            value={dataSubmit.attribute71}
            onChange={(e) =>
              setDataSubmit((prev) => ({
                ...prev,
                attribute71: e.currentTarget.value,
              }))
            }
          />
        </Grid.Col>
      </Grid>
      <Flex justify={"end"} gap={"md"} mt={5}>
        <Button
          leftSection={<IconCheck />}
          onClick={() => handleSubmit()}
          loading={loadingButton}
          disabled={loadingButton}
        >
          Lưu
        </Button>
      </Flex>
    </Box>
  );
};

export default TransferShippingFromCOD;
